module.exports = __webpack_public_path__ + "static/media/17-bday-hike_09_26_2020.229d3675.jpg";